package team.platforma.multiplatform_material_extension.util.forms

import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.input.key.Key
import androidx.compose.ui.input.key.KeyEventType
import androidx.compose.ui.input.key.key
import androidx.compose.ui.input.key.onPreviewKeyEvent
import androidx.compose.ui.input.key.type


fun Modifier.keyListener(key: Key, keyPressed:()-> Unit): Modifier {
   return this.onPreviewKeyEvent { event ->
        if (event.type == KeyEventType.KeyDown && event.key == key) {
            keyPressed.invoke()
            true
        } else {
            false
        }
    }
}